import { useExperiments } from '@jusbrasil-web/docview/core'
import {
  SD_DOCVIEW_CHATS_EXPERIMENT_NAME,
  SD_DOCVIEW_CHATS_VARIANTS,
} from '@jusbrasil-web/shared-seus-direitos'
import type { ResolvedArticleQuiz } from '@jusbrasil-web/shared-seus-direitos/article-quizzes'

export interface SdChatWebDocviewExperimentInput {
  summaryItems: string[] | null
  quiz: ResolvedArticleQuiz | null
}

export interface SdChatWebDocviewExperimentResult {
  isInVariantA: boolean
  isInVariantB: boolean
  /** True quando o usuário está em variantA E o artigo tem summary items cadastrados. */
  isChatWebEligible: boolean
  /** True quando o usuário está em variantB E o artigo tem quiz cadastrado. */
  isQuizEligible: boolean
  /**
   * True quando alguma das variantes ativas do experimento está habilitada (isChatWebEligible
   * || isQuizEligible). Único sinal que os clients devem consultar para gatear qualquer mudança
   * visual ou comportamental compartilhada entre as variantes (ex.: esconder o CTA legado e o
   * toolbar do header).
   */
  isSdChatExperimentOn: boolean
}

export function useSdChatWebDocviewExperiment({
  summaryItems,
  quiz,
}: SdChatWebDocviewExperimentInput): SdChatWebDocviewExperimentResult {
  const { isParticipating } = useExperiments()
  const isInVariantA = isParticipating(
    SD_DOCVIEW_CHATS_EXPERIMENT_NAME,
    SD_DOCVIEW_CHATS_VARIANTS.VARIANT_A
  )
  const isInVariantB = isParticipating(
    SD_DOCVIEW_CHATS_EXPERIMENT_NAME,
    SD_DOCVIEW_CHATS_VARIANTS.VARIANT_B
  )

  const isChatWebEligible = isInVariantA && summaryItems !== null
  const isQuizEligible = isInVariantB && quiz !== null
  const isSdChatExperimentOn = isChatWebEligible || isQuizEligible

  return {
    isInVariantA,
    isInVariantB,
    isChatWebEligible,
    isQuizEligible,
    isSdChatExperimentOn,
  }
}
